import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SharedModule } from '../shared.module';
import { TodayOverviewComponent } from '../today-overview/today-overview.component';

// Shown after every login/start-day so the user has a quick recall of what's
// on their plate today — informational only, no action required to dismiss.
@Component({
  selector: 'app-today-overview-dialog',
  standalone: true,
  imports: [CommonModule, SharedModule, MatDialogModule, TodayOverviewComponent],
  templateUrl: './today-overview-dialog.component.html',
  styleUrl: './today-overview-dialog.component.scss',
})
export class TodayOverviewDialogComponent {
  private dialogRef = inject(MatDialogRef<TodayOverviewDialogComponent>);

  close(): void {
    this.dialogRef.close();
  }
}
